import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CalculationBaseFormFactory } from './calculation-base-form.factory';
import {
  CalculationResponse,
} from '../../../../../../../../../../../common/dist/angular/responses/calculation.response';
import {
  CalculationStatusEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-status.enum';
import { TranslateService } from '@ngx-translate/core';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  CalculationRunOptions,
} from '../../../../../../../../../../../common/src/options/calculations/calculation-run.options';
import { CalculationsUtils } from '../../../../../utils/calculations.utils';
import { AlertMessageStore } from '../../../../../../core/stores/alert-message.store';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import {
  CalculationKeynameEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { Subscription } from 'rxjs';

@Component({
  template: '',
  standalone: false,
})
export abstract class QuickCalculationBaseForm<T extends CalculationRunOptions> implements OnInit, OnDestroy {
  calculationResponse: CalculationResponse;

  public lastModified: Date;

  public calculationStatusEnum: CalculationStatusEnum;

  // @ts-ignore
  public form: AdvancedForm<T> = this.formFactory.create();
  public numberOfErrors = 0;
  onFormChangeSubscription: Subscription;
  protected optionsType: { new(...args: any[]): object; };

  constructor(public readonly formFactory: CalculationBaseFormFactory,
              protected readonly translateService: TranslateService,
              private readonly optionsMapper: OptionsMapper,
              private readonly calculationsUtils: CalculationsUtils,
              private readonly alertMessageStore: AlertMessageStore,
              private readonly calculationKeyname: CalculationKeynameEnum,
  ) {

  }

  ngOnInit(): void {
    // Right away, we want to form to be set as loading.
    this.form.lifecycleStatus = FormLifecycleStatusEnum.Loading;

    // Unsubscribe all the subscriptions on route change.
    this.unsubscribeAll();

    this.onFormChangeSubscription = this.form.value$.subscribe((value) => {
      this.refresh();
    });

    this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
  }

  /**
   * This method exists so that forms extending the base form can be notified when the calculation has
   * been updated and proceed to update some fields.
   */
  postUpdateCallback() {

  }

  ngOnDestroy() {
    console.log('Quick calculation base Form is being destroyed');

    this.unsubscribeAll();
  }

  refresh() {
    const a = 0;
  }

  getStatusText(): string {
    return this.calculationsUtils.getStatusText(this.calculationStatusEnum);
  }

  getLastModifiedText() {
    return this.calculationsUtils.getLastModifiedText(this.lastModified);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    if (this.form.pristine === true ||
      this.calculationStatusEnum === CalculationStatusEnum.Completed ||
      this.calculationStatusEnum === CalculationStatusEnum.Error ||
      this.calculationStatusEnum === CalculationStatusEnum.InProgress) {
      return true;
    }
    return false;
  }

  private unsubscribeAll() {
    this.onFormChangeSubscription?.unsubscribe();
  }
}
